
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(1889|6216)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
